import React,{useEffect, useState} from "react";
import { ChevronRight } from "lucide-react";
import './../css/Subjects.css'
import axios from "./../../axios";
import { useNavigate } from "react-router-dom";
const AssignedClasses = ()=>{
   const [subjects, setSubjects] = useState([
  { name: 'loading...', alert: false },
   
]);
  useEffect(() => {
  const fetchData = async () => {
    try {
       const staff = JSON.parse(localStorage.getItem("staff")); // or pass from props/context

      const response = await axios.get('staff/teacher_classes', {
        params: {
          id:staff.id, // ✅ clean header
        },
      });
 
      console.log(response.data);
      setSubjects(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchData();
}, []);
useEffect(
()=>{
const sortedSubjects = subjects.sort((a, b) => b.alert - a.alert);
setSubjects([...sortedSubjects]);

},[]
);
const navigate = useNavigate();

  return(  <>
  
  <div className="subject-title-area"> 
    <div className="title-subject">
    Assigned Classes
    </div>
    {/* <div className="viewAll-subjects"  >
        View All <ChevronRight/>
    </div> */}
  </div>
    <div className="subject-containor"  >
        {subjects.map((subject, index) => (
  <div className="subject" key={index} onClick={()=>navigate(`/staff/student-list/${subject.classname_id}/${subject.section}`)}>
    
    {subject.name}
    {subject.alert ? (
    <div className="subject-dot"></div>

    ):null}
  
  </div>
))}
       
    </div>
    </>
    );
};

export default AssignedClasses;